__webpack_require__.p = "https://mzdata-static.oss-cn-zhangjiakou.aliyuncs.com/customer/dataone-frontend/prod/";